import download from "downloadjs";
//import { Buffer } from "buffer"

  export function decodeBase64(base64) {
    //const object = base64.replace('data:application/pdf;base64,', '');
    //const binary = Buffer.from(base64,'base64').toString('binary');
    const binary = atob(base64.replace(/\s/g, ""))
    const len = binary.length;
    const buffer = new ArrayBuffer(len);

    let view = new Uint8Array(buffer);

    for (let i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i);
    }

    return view;
  }

  export function showFile(blob,name) {
    const newBlob = new Blob([blob], { type: 'application/pdf' });
    download(newBlob,`${name}.pdf`)

    // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //   window.navigator.msSaveOrOpenBlob(newBlob);
    //   return;
    // }

    // const data = window.URL.createObjectURL(newBlob);
    // const link = document.createElement('a');
    // link.href = data;
    // link.download = `${name}.pdf`;
    // link.click();
    // setTimeout(() => {
    //   window.URL.revokeObjectURL(data);
    // }, 100);
  }

  export default function Base64ToPDF(data,fileName){
    showFile(decodeBase64(data),fileName)
  }
